'use strict';

var borderRadii = require('../../../../../../../../_virtual/borderRadii.cjs');

var hasRequiredBorderRadii;

function requireBorderRadii () {
	if (hasRequiredBorderRadii) return borderRadii.__exports;
	hasRequiredBorderRadii = 1;

	const AviaryBorderRadii = {
	    small: "small",
	    medium: "medium",
	    circular: "circular"
	};

	borderRadii.__exports.AviaryBorderRadii = AviaryBorderRadii;
	
	return borderRadii.__exports;
}

exports.__require = requireBorderRadii;
//# sourceMappingURL=borderRadii.cjs.map
